import { useAtomValue } from "jotai";
import React from "react";

import { Loader } from "@whoosh/design-system/src/components/display";

import { OverlayLoading_atom } from "./atoms";

export const OverlayLoader = ({ isOpen }: { isOpen?: boolean }) => {
  const isLoading = useAtomValue(OverlayLoading_atom);

  return !!isLoading || isOpen ? <Loader /> : null;
};
